import { render, staticRenderFns } from "./mgcGameListModal.vue?vue&type=template&id=2923d6aa&scoped=true"
import script from "./mgcGameListModal.vue?vue&type=script&lang=js"
export * from "./mgcGameListModal.vue?vue&type=script&lang=js"
import style0 from "./mgcGameListModal.vue?vue&type=style&index=0&id=2923d6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923d6aa",
  null
  
)

export default component.exports